import axios from "axios";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled, { css } from "styled-components";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";

import Aos from "aos";
import "aos/dist/aos.css";
import { Autoplay, Navigation } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import SimpleButton from "../components/Buttons/SimpleButton";
import Column from "../components/Column/Column";
import RoundedProfilePic from "../components/Images/RoundedProfilePic";
import { NavBar } from "../components/NavBar";
import Row from "../components/Row/Row";
import Text from "../components/Text/Text";
import { useAuth } from "../hooks/useAuth";
import eth_icon from "../imgs/eth_icon_blue.svg";

import search_icon from "../imgs/search_icon.svg";
import search_icon_light from "../imgs/search_icon_purple.svg";

import newsletter_bg from "./imgs/newsletter_bg.png";

import default_song_cover_1 from "./imgs/default_song_cover1.png";

import Footer from "../components/Footer/Footer";
import HowItWorks, { HowItWorksRow } from "../components/howitworks/HowItWorks";
import { SectionSubTitle, SectionTitle } from "../components/Text/SectionTitle";
import ELE47N from "./imgs/ELE47N.png";
import eliska from "./imgs/eliska.png";
import homepage_bg from "./imgs/homepage_bg.png";
import jazzy from "./imgs/jazzy.png";
import liljohnjohn from "./imgs/liljohnjohn.png";
import lovetolii from "./imgs/lovetolii.png";
import stan from "./imgs/stan.png";
import vic from "./imgs/vic.png";
import sussy from './imgs/sussy.png';
import raystorme from './imgs/raystorme.png';
import linda_sol from './imgs/lindasol.png';

const HeaderText = styled.h2`
  color: ${(props) => props.theme.body};
  font-style: normal;
  font-weight: 500;
  font-size: 24px;
  line-height: 35.7px;
  padding-inline: 10%;
  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const Title = styled.h1`
  color: ${(props) => props.theme.body};
  font-style: normal;
  font-weight: 500;
  font-size: 64px;

  @media screen and (max-width: 650px) {
    font-size: 22px;
    font-weight: 700;
    padding-inline: 5%;
  }
`;

const HomePageContainer = styled("div")<{ theme: string }>`
  background: url(${homepage_bg}) center;
  background-size: cover;
  min-height: 100vh;
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  color: white;

  @media screen and (max-width: 650px) {
    min-height: 0;
    padding-top: 30%;
    flex-wrap: wrap-reverse;
  }
`;

interface HomepageProps {
  themeToggler: any;
  theme: string;
}

const SearchButton = styled(SimpleButton)`
  position: absolute;
  right: 0;
  border-radius: 5px;
  padding: ${(props) =>
    props.theme.themeType === "dark" ? "1.2rem 2.5rem" : "1.5rem 2.5rem"};
`;

const SearchBarContainer = styled("div")`
  align-self: flex-start;
  width: 100%;
  display: flex;
  flex-direction: row;
  border: ${(props) =>
    props.theme.themeType === "dark"
      ? "0.5px solid #374669"
      : "0.5px solid #575DFB"};
  border-radius: 5px;
  background: ${(props) =>
    props.theme.themeType === "dark" ? "rgba(196, 196, 196, 0.1)" : "white"};
  box-shadow: ${(props) =>
    props.theme.themeType === "dark"
      ? "inset 30.9667px -30.9667px 30.9667px rgba(149, 149, 149, 0.1), inset -30.9667px 30.9667px 30.9667px rgba(255, 255, 255, 0.1)"
      : ""};
  backdrop-filter: blur(61.9333px);
  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  padding: 10px;
`;

const SearchIcon = styled.img`
  padding-left: 20px;
`;

const SearchBar = styled("input")`
  outline: none;
  border: none;
  background: none;
  font-size: 1em;
  padding: 0.5em;
  color: ${(props) => (props.theme.themeType === "dark" ? "white" : "black")};
  flex: auto 1 1;
  width: 100%;
  background: none;
  background-color: transparent;
  font-family: "Spartan";

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */

    color: ${(props) => (props.theme.themeType === "dark" ? "white" : "gray")};
    opacity: 1; /* Firefox */
  }
`;
const NewsletterSearchContainer = styled("div")`
  position: relative;
  margin-right: 10%;
  margin-bottom: 2%;
  width: 150%;
  height: 1rem;
  display: flex;
  flex-direction: row;
  align-self: flex-end;

  background: rgba(255, 255, 255, 0.2);
  border: 0.5px solid #ffffff;
  border-radius: 8px;
  align-items: center;
  overflow: hidden;
  padding: 10px;
  margin-left: auto;

  @media screen and (max-width: 650px) {
    width: 100%;
    margin-top: 25%;
    margin-bottom: 15%;
  }
`;

const NewsLetterSearchBar = styled("input")`
  outline: none;
  border: none;
  background: none;
  font-size: 1em;
  padding: 0.5em;
  flex: auto 1 1;
  width: 30%;
  border-radius: 10px;

  background: transparent;
  font-family: "Spartan";
  color: white;

  &::placeholder {
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    color: gray;

    opacity: 1; /* Firefox */
  }
`;

const NewsletterButton = styled(SimpleButton)`
  position: absolute;
  right: 0;
  border-radius: 5px;
  padding: 1.2rem 2rem;
  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const NewsletterButtonMobile = styled(SimpleButton)`
  border-radius: 5px;

  @media screen and (min-width: 650px) {
    display: none;
  }
`;

interface SearchInputProps {
  onTextChange: (text: string) => void;
  theme: string;
  onSearchClick?: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SearchInput = ({
  onTextChange,
  theme,
  onSearchClick,
  onKeyDown,
}: SearchInputProps) => {
  const onInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onTextChange(event.target.value);
  };

  return (
    <>
      <SearchBarContainer>
        <SearchIcon src={theme === "dark" ? search_icon : search_icon_light} />
        <SearchBar
          onKeyDown={onKeyDown}
          onChange={onInputChange}
          placeholder={"Search by artist, song, or other keywords"}
        />
        <SearchButton onClick={onSearchClick}>Search</SearchButton>
      </SearchBarContainer>
    </>
  );
};

const NewsletterSection = styled.div`
  ${(props) =>
    props.theme.themeType === "dark" &&
    css`
      background: url(${newsletter_bg}) no-repeat center;
    `};

  ${(props) =>
    props.theme.themeType === "light" &&
    css`
      background: #879ae4;
    `};
  background-size: cover;
  padding-left: 10%;
  padding-top: 5%;
  padding-bottom: 2%;
  display: flex;
  align-items: center;

  @media screen and (max-width: 650px) {
    padding-bottom: 10%;
    justify-content: center;
    padding-left: 0;
    padding-bottom: 10%;
    padding-top: 10%;
  }
`;

const TrendingSongsSection = styled.div`
  ${(props) =>
    props.theme.themeType === "dark" &&
    css`
      background: #000d30;
    `}
  background-size: cover;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  display: none;

  @media screen and (max-width: 650px) {
    display: block;
  }
`;
const TrendingSongsLoggedInSection = styled.div`
  ${(props) =>
    props.theme.themeType === "dark" &&
    css`
      background: #000d30;
    `}
  background-size: cover;
  padding-inline: 10%;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media screen and (max-width: 650px) {
    display: none;
  }
`;
const HowItWorksSection = styled.div`
  ${(props) =>
    props.theme.themeType === "dark" &&
    css`
      background: #000d30;
    `}
  background-size: cover;
  padding-inline: 10%;
  padding-bottom: 10%;
  padding-top: 7%;
  position: relative;
`;

const TopArtistsSection = styled.div`
  ${(props) =>
    props.theme.themeType === "dark" &&
    css`
      background: #000d30;
    `}
  background-size: cover;
  padding-inline: 10%;
  padding-top: 5%;
  position: relative;

  @media screen and (max-width: 650px) {
    padding-inline: 0%;
  }
`;

const SongCoverImg = styled("img")`
  width: 100%;
  max-height: 30vh;
  min-width: 25vw;
  object-fit: cover;
  border-radius: 10px 8px 0 0;

  &:hover {
    cursor: pointer;
  }
`;

const SongInfo = styled(Column)`
  border-radius: 0px 0px 30px 30px;
  justify-content: flex-start;
  padding-right: 10px;
`;

const SongInfoProfilePic = styled(RoundedProfilePic)`
  width: 40px;
  height: 40px;
  margin-bottom: 10px;
  margin-right: 5px;
`;

const SongInfoName = styled(Text)`
  margin-left: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
  font-weight: 600;
  font-size: 18px;
`;

const PriceTextContainer = styled("div")`
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  color: ${(props) => (props.theme.themeType === "dark" ? "white" : "black")};
`;

const ArtistInfoText = styled(Text)`
  font-size: 16px;
`;

const ArtistInfoRow = styled(Row)`
  justify-content: flex-start;
`;

const ExploreButton = styled(SimpleButton)`
  padding-inline: 4%;
  padding-block: 1.8%;

  @media screen and (max-width: 650px) {
    margin-right: auto;
    margin-left: auto;
    padding-block: 5%;
    padding-inline: 10%;
  }
`;

const LearnMoreButton = styled(SimpleButton)`
  padding-inline: 4%;
  padding-block: 1.8%;
  margin-left: 5%;

  @media screen and (max-width: 650px) {
    padding-inline: 8%;
    padding-block: 3%;
    margin-left: 0%;
  }

  &:hover {
    box-shadow: 0px 0px 20px rgba(255, 255, 255, 0.40);
    backdrop-filter: blur(19.6px);
  }
`;

const CustomSwiper = styled(Swiper)`
  display: none;
  background: #000d30;
  padding-bottom: 10%;
  .swiper-slide {
    background: ${(props) =>
      props.theme.themeType === "dark" ? "rgba(196, 196, 196, 0.1)" : "white"};
    border: ${(props) =>
      props.theme.themeType === "dark"
        ? "0.2px solid #ffffff40"
        : "1px solid #575DFB"};

    ${(props) =>
      props.theme.themeType === "dark" &&
      css`
        box-shadow: inset 30.9667px -30.9667px 30.9667px rgba(149, 149, 149, 0.1),
          inset -30.9667px 30.9667px 30.9667px rgba(255, 255, 255, 0.1);
      `}
    backdrop-filter: "blur(61.9333px)";
    width: 100%;
    border-radius: 10px;
    transform: scale(0.9);
  }

  .swiper-button-next::after,
  .swiper-button-prev::after {
    content: "";
  }

  @media screen and (max-width: 600px) {
    display: block;
    background: #000d30;
    .swiper-slide {
      background: ${(props) =>
        props.theme.themeType === "dark"
          ? "rgba(196, 196, 196, 0.1)"
          : "white"};
      border: ${(props) =>
        props.theme.themeType === "dark"
          ? "0.2px solid #ffffff40"
          : "1px solid #575DFB"};

      ${(props) =>
        props.theme.themeType === "dark" &&
        css`
          box-shadow: inset 30.9667px -30.9667px 30.9667px rgba(149, 149, 149, 0.1),
            inset -30.9667px 30.9667px 30.9667px rgba(255, 255, 255, 0.1);
        `}
      backdrop-filter: "blur(61.9333px)";
      border-radius: 10px;
      transform: scale(0.8);
    }
  }
`;

const NewReleasesSection = styled.div`
  background: #000d30;
  background-size: cover;
`;
const NewReleasesSectionInfo = styled.div`
  padding: 10%;
  display: flex;
  position: relative;

  @media screen and (max-width: 650px) {
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
`;

const OurMissionSection = styled.div`
  background: #000d30;
  background-size: cover;
`;

const OurMissionInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10%;
  padding-bottom: 10%;
  padding-right: 5%;
`;

const MissionItems = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
`;

const MissionItem = styled.div`
  margin-left: 15px;
  flex: 40%;
  padding-bottom: 5%;
  margin-left: auto;
  margin-right: auto;
  &:before {
    content: "";
    display: block;
    width: 8px;
    height: 160px;
    background: #9d7cff;
    margin-left: -20px;
    position: absolute;
  }

  @media screen and (max-width: 1200px) {
    flex: 1 1 auto;
    padding-bottom: 10%;

    &:before {
      content: "";
      display: block;
      width: 8px;
      max-height: 100px;
      min-height: 100px;
      background: #9d7cff;
      margin-left: -20px;
      margin-top: 10px;
      position: absolute;
    }
  }
`;

const MissionItemText = styled(Text)`
  margin-top: 8%;
  font-size: 18px;
  width: 80%;

  @media screen and (max-width: 650px) {
    font-size: 14px;
    width: 90%;
  }
`;

const OurTeamSection = styled.div`
  background: #000d30;
  background-size: cover;
`;

const OurTeamInfo = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 10%;
  padding-bottom: 10%;

  @media screen and (max-width: 650px) {
    justify-content: center;
    align-items: center;
    padding-left: 0;
  }
`;

const RightColumn = styled(Column)`
  width: 40%;
  margin-left: auto;
  align-items: end;

  @media screen and (max-width: 650px) {
    width: 100%;
    align-items: center;
    justify-content: center;
    text-align: center;
  }
`;

const NFTAvatars = styled(RoundedProfilePic)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 20%;
  width: 13rem;
  height: 13rem;
  border-radius: 50%;

  &:hover {
    cursor: pointer;
  }
`;

const TitleRow = styled(Column)`
  margin-top: "5%";
  padding-top: 15%;
  justify-content: flex-start;
  text-align: center;
  align-items: center;

  @media screen and (max-width: 650px) {
    padding: 0%;
  }
`;

const NewReleasesColumn = styled.div`
  padding-top: 10%;
  padding-bottom: 10%;
  z-index: 2;

  @media screen and (max-width: 650px) {
    text-align: center;
  }
`;

const TeamRow = styled(Row)`
  justify-content: space-between;
  gap: 10%;
  flex-wrap: wrap;
  margin-right: 10%;

  @media screen and (max-width: 650px) {
    justify-content: center;
    margin-right: 0%;
  }
`;

const CreateNFTButton = styled(ExploreButton)`
  @media screen and (max-width: 650px) {
    display: none;
  }



  backdrop-filter: blur(19.6px)


`;

const NewsletterSectionColumn = styled(Column)`
  padding-bottom: 5%;
  @media screen and (max-width: 650px) {
    justify-content: center;
    align-items: center;
  }
`;

const TitleButtonRow = styled(Row)`
  justify-content: center;
  width: 100%;
`;

const NewReleasesImg = styled.img`
  filter: blur(50px);
  opacity: 0.4;
  position: absolute;
  width: 80%;
  height: 80%;
  object-fit: contain;
  z-index: 0;
  left: 10%;

  @media screen and (max-width: 650px) {
    display: none;
  }
`;

const SongCover = styled.div`
  border: 0.5px solid #ffffff80;
  border-radius: 10px;
  height: 50%;
  margin-left: auto;
  margin-top: 5%;
  margin-right: 10%;

  @media screen and (max-width: 650px) {
    margin-left: auto;
    margin-right: auto;
  }
`;

const TrendingSongCover = styled(SongCover)`
  margin-right: 0;

  @media screen and (max-width: 650px) {
    width: 100%;
  }
`;

const HeaderTextMobile = styled(Text)`
  display: none;
  @media screen and (max-width: 650px) {
    display: block;
    padding: 5%;
    font-size: 14px;
  }
`;

const TopArtistProfile = styled(Column)`
  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
    transform: scale(1.1);
    transition: 0.2s ease-in;
  }
`;

const TopArtistProfilePic = styled(RoundedProfilePic)`
  border-radius: 50%;
  width: 125px;
  height: 125px;

  @media screen and (max-width: 650px) {
    width: 100px;
    height: 100px;
  }
`;

const TopArtistMobile = styled.div`
  display: none;
  @media screen and (max-width: 650px) {
    display: block;
  }
`;
const TopArtistDesktop = styled.div`
  @media screen and (max-width: 650px) {
    display: none;
  }
`;
export const Homepage: React.FC<HomepageProps> = ({ theme, themeToggler }) => {
  const navigate = useNavigate();
  const auth = useAuth();
  const currentUser = auth.user;
  const [searchFilter, setSearchFilter] = useState("song");
  const [searchQuery, setSearchQuery] = useState("");
  const [signupText, setSignUpText] = useState("Sign up");
  const [email, setEmail] = useState("");
  const featuredSongCover = "https://compose-nft.infura-ipfs.io/ipfs/QmRweZRGgRrJk2kh5aixX2JPoALiPu24zzpBuqX4xnAF4r/IMG_5590.JPEG";
  const featuredArtistProfilePic = "https://compose-nft.infura-ipfs.io/ipfs/QmRweZRGgRrJk2kh5aixX2JPoALiPu24zzpBuqX4xnAF4r/IMG_5590.JPEG";
  const featuredSongLink = "/collection/4"
  const exploreFeaturedSongCover1 = "https://compose-nft.infura-ipfs.io/ipfs/QmNpYevgMatEiFf4Pe4tu3L1pPKzyPtC8bLy1LmzJUtY2D/photo-output_2.JPG";
  const exploreFeaturedSongLink1 = "/collection/3";
  const exploreFeaturedSongLink2 = "/collection/6";
  const exploreFeaturedSongLink3 = "/song/12";
  const exploreFeaturedSongName1 = "Demons";
  const exploreFeaturedSongPrice1 = "0.04 ETH";
  const exploreFeaturedArtistPic1 = "https://1fsihk931c.execute-api.us-east-1.amazonaws.com/prod/s3/betacomposenft/song_covers/0x68B20c6f311c88bAEd839238649cD670a2fD3Ac7_photo-output_2_1669944584.JPG";
  const exploreFeaturedArtistName1 = "LilJohnJohn";
  const exploreFeaturedSongCover2 = "https://compose-nft.infura-ipfs.io/ipfs/QmRweZRGgRrJk2kh5aixX2JPoALiPu24zzpBuqX4xnAF4r/IMG_5590.JPEG";
  const exploreFeaturedSongName2 = "Catch This Vibe";
  const exploreFeaturedSongPrice2 = "0.0079 ETH";
  const exploreFeaturedArtistPic2 = "https://compose-nft.infura-ipfs.io/ipfs/QmRweZRGgRrJk2kh5aixX2JPoALiPu24zzpBuqX4xnAF4r/IMG_5590.JPEG";
  const exploreFeaturedArtistName2 = "LoveToliii";
  const exploreFeaturedSongCover3 = "https://compose-nft.infura-ipfs.io/ipfs/QmbwbuSv4tmP1v1omCjnM9535wcKXMKXLRZ5Jn2VNNEovP/dynamismm.PNG";
  const exploreFeaturedSongName3 = "Dynamism";
  const exploreFeaturedArtistPic3 = "https://1fsihk931c.execute-api.us-east-1.amazonaws.com/prod/s3/betacomposenft/profile_pics/0x6338B2E4728D58574130B9Cba243dCd0d44416E0_profile_pic_1667878225.PNG";
  const exploreFeaturedSongPrice3 = "3 ETH";
  const exploreFeaturedArtistName3 = "ELE47N";

  const artistsTopRow = [
    "LoveToliii",
    "Ray Storme",
    "Sussy",
    "Linda Sol",
  ];

  const artistsTopRowUserLinks = [
    "/user/0x2c7745EBE290Fa8eD9B40b1E71CBA12D25Ba8CB2",
    "",
    "",
    "",
  ];
  const artistsBottomRow = ["LilJohnJohn", "ELE47N", "Justin A."];
  const artistsBottomRowUserLinks = ["/user/0x68B20c6f311c88bAEd839238649cD670a2fD3Ac7", 
  "/user/0x6338B2E4728D58574130B9Cba243dCd0d44416E0", ""];

  const artistProfilePicsTopRow = [
    lovetolii,
    raystorme,
    sussy,
    linda_sol,
  ];

  const artistProfilePicsBottomRow = [
    liljohnjohn,
    ELE47N,
    default_song_cover_1,
  ];

  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);

  const onExploreClick = () => {
    navigate("/explore");
  };

  const onLearnMoreClick = () => {
    navigate("/articles/2");
  };

  const onSearchClick = () => {
    navigate("/explore", { state: { searchQuery: searchQuery } });
  };

  const onTextChange = (text: string) => {
    setSearchQuery(text);
  };

  const onTopArtistClick = (index) => {
    navigate(artistsTopRowUserLinks[index])
  }

  const onTopArtistBottomRowClick = (index) => {
    navigate(artistsBottomRowUserLinks[index])
  }

  const enterToSearch = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      onSearchClick();
    }
  };

  const onNewsletterSignUpClick = () => {
    const formData = new FormData();
    formData.append("entry.97899463", email);
    axios.post(
      "https://docs.google.com/forms/d/e/1FAIpQLScq3VTIfJIR4vmkfEnaCzbYlwgNBEuZT0PNhDbxUeirB0iXlA/formResponse?",
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    setSignUpText("Thanks!");
  };
  const onEmailChange = (changeEvent: React.ChangeEvent<HTMLInputElement>) => {
    setEmail(changeEvent.target.value);
  };

  const onViewAllClick = () => {
    navigate("/explore");
  };

  const onAvatarClick = (employee: string) => {
    navigate("/aboutus", { state: { navTo: employee } });
  };

  const getSlidesPerView = () => {
    if (window.screen.width < 1200) {
      return 1.2;
    } else {
      return 5;
    }
  };

  const onCreateNFTClick = () => {
    navigate("/create_nft");
  };

  return (
    <>
      {!currentUser && (
        <>
          <NavBar theme={theme} themeToggler={themeToggler} />
          <HomePageContainer theme={theme}>
            <TitleRow data-aos="fade-down">
              <Title>JOIN THE MUSIC PLATFORM OF THE FUTURE</Title>
              <HeaderText>
                A web3 music platform that empowers muscians by allowing fans to
                invest in and license their music.
                <br></br>
                <br></br>
                <br></br>
              </HeaderText>

              <HeaderTextMobile>
              A web3 music platform that empowers muscians by allowing fans to
                invest in and license their music.
              </HeaderTextMobile>
              <TitleButtonRow>
                {theme === "dark" ? (
                  <CreateNFTButton onClick={onCreateNFTClick}>
                    Create NFT
                  </CreateNFTButton>
                ) : (
                  <SimpleButton bg="#07C0C6" onClick={onExploreClick}>
                    Explore
                  </SimpleButton>
                )}

                <LearnMoreButton secondary onClick={onLearnMoreClick}>
                  Learn More
                </LearnMoreButton>
              </TitleButtonRow>
            </TitleRow>
          </HomePageContainer>
        </>
      )}
      {currentUser !== null && (
        <>
          <NewReleasesSection>
            <NavBar theme={theme} themeToggler={themeToggler} />
            <NewReleasesImg src={featuredSongCover} />

            <NewReleasesSectionInfo data-aos="fade-down">
              <NewReleasesColumn>
                <Column style={{ marginLeft: "30px" }}>
                  <SectionTitle bold={true} size={"48px"}>
                    NEW RELEASES
                  </SectionTitle>
                  <SectionSubTitle>
                    DISCOVER THE
                    <br></br>NEWEST DROPS
                  </SectionSubTitle>
                </Column>
              </NewReleasesColumn>
              <SongCover onClick={() => {navigate(featuredSongLink)}}>
                <SongCoverImg src={featuredSongCover} height={"200px"} />
                <SongInfo>
                  <SongInfoName>Hell Or Peace</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={featuredArtistProfilePic} />
                    <ArtistInfoText>LoveToliii</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      0.00789 ETH
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </SongCover>
            </NewReleasesSectionInfo>
          </NewReleasesSection>
          <TrendingSongsLoggedInSection>
            <Column style={{ textAlign: "center" }}>
              <SectionTitle>TRENDING SONGS</SectionTitle>
              <SectionSubTitle>MOST LOVED BY USERS</SectionSubTitle>
            </Column>
            <Row gap="1rem" style={{ flexWrap: "wrap" }}>
              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink1)}}>
                <SongCoverImg src={exploreFeaturedSongCover1} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName1}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic1} />
                    <ArtistInfoText>{exploreFeaturedArtistName1}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice1}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>

              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink2)}}>
                <SongCoverImg src={exploreFeaturedSongCover2} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName2}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic2} />
                    <ArtistInfoText>{exploreFeaturedArtistName2}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice2}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>
              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink3)}}>
                <SongCoverImg src={exploreFeaturedSongCover3} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName3}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic3} />
                    <ArtistInfoText>{exploreFeaturedArtistName3}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice3}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>
            </Row>
            <SimpleButton onClick={onExploreClick} style={{ marginTop: "3%" }}>
              Explore
            </SimpleButton>
          </TrendingSongsLoggedInSection>
        </>
      )}

      {currentUser === null && (
        <NewReleasesSection>
          <NewReleasesImg src={featuredSongCover} />

          <NewReleasesSectionInfo data-aos="fade-down">
            <NewReleasesColumn>
              <Column style={{ marginLeft: "30px" }}>
                <SectionTitle bold={true} size={"48px"}>
                  NEW RELEASES
                </SectionTitle>
                <SectionSubTitle>
                  DISCOVER THE
                  <br></br>NEWEST DROPS
                </SectionSubTitle>
              </Column>
            </NewReleasesColumn>
            <SongCover onClick={() => {navigate(featuredSongLink)}}>
              <SongCoverImg src={exploreFeaturedSongCover2} height={"200px"} />
              <SongInfo>
               <SongInfoName>Hell Or Peace</SongInfoName>
                <ArtistInfoRow>
                  <SongInfoProfilePic bg={exploreFeaturedArtistPic2} />
                  <ArtistInfoText>{exploreFeaturedArtistName2}</ArtistInfoText>
                  <PriceTextContainer>
                    <img src={eth_icon} />
                    0.00789 ETH
                  </PriceTextContainer>
                </ArtistInfoRow>
              </SongInfo>
            </SongCover>
          </NewReleasesSectionInfo>
        </NewReleasesSection>
      )}

      {currentUser === null ? (
        <>
          <TrendingSongsLoggedInSection>
            <Column style={{ textAlign: "center" }}>
              <SectionTitle>TRENDING SONGS</SectionTitle>
              <SectionSubTitle>MOST LOVED BY USERS</SectionSubTitle>
            </Column>
            <Row gap="1rem" style={{ flexWrap: "wrap" }}>
              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink1)}}>
                <SongCoverImg src={exploreFeaturedSongCover1} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName1}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic1} />
                    <ArtistInfoText>{exploreFeaturedArtistName1}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice1}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>

              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink2)}}>
                <SongCoverImg src={exploreFeaturedSongCover2} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName2}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic2} />
                    <ArtistInfoText>{exploreFeaturedArtistName2}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice2}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>
              <TrendingSongCover onClick={() => {navigate(exploreFeaturedSongLink3)}}>
                <SongCoverImg src={exploreFeaturedSongCover3} height={"200px"} />
                <SongInfo>
                  <SongInfoName>{exploreFeaturedSongName3}</SongInfoName>
                  <ArtistInfoRow>
                    <SongInfoProfilePic bg={exploreFeaturedArtistPic3} />
                    <ArtistInfoText>{exploreFeaturedArtistName3}</ArtistInfoText>
                    <PriceTextContainer>
                      <img src={eth_icon} />
                      {exploreFeaturedSongPrice3}
                    </PriceTextContainer>
                  </ArtistInfoRow>
                </SongInfo>
              </TrendingSongCover>
            </Row>

            <SimpleButton onClick={onExploreClick} style={{ marginTop: "3%" }}>
              Explore
            </SimpleButton>
          </TrendingSongsLoggedInSection>

          <TrendingSongsSection>
            <SectionTitle bold={true} size={"48px"}>
              TRENDING SONGS
            </SectionTitle>
          </TrendingSongsSection>
          <CustomSwiper
            slidesPerView={getSlidesPerView()}
            spaceBetween={-50}
            centeredSlides={true}
            initialSlide={0}
            loop={true}
            modules={[Autoplay, Navigation]}
            autoplay={{ delay: 5000 }}
            navigation={true}
            className="mySwiper"
          >
            <SwiperSlide onClick={() => navigate(exploreFeaturedSongLink1)}>
              <SongCoverImg src={exploreFeaturedSongCover1} height={"200px"} />
              <SongInfo>
                <SongInfoName>{exploreFeaturedSongName1}</SongInfoName>
                <ArtistInfoRow>
                  <SongInfoProfilePic bg={exploreFeaturedArtistPic1} />
                  <ArtistInfoText>{exploreFeaturedArtistName1}</ArtistInfoText>
                  <PriceTextContainer>
                    <img src={eth_icon} />
                    {exploreFeaturedSongPrice1}
                  </PriceTextContainer>
                </ArtistInfoRow>
              </SongInfo>
            </SwiperSlide>

            <SwiperSlide onClick={() => navigate(exploreFeaturedSongLink2)}>
              <SongCoverImg src={exploreFeaturedSongCover2} height={"200px"} />
              <SongInfo>
                <SongInfoName>{exploreFeaturedSongName2}</SongInfoName>
                <ArtistInfoRow>
                  <SongInfoProfilePic bg={exploreFeaturedArtistPic2} />
                  <ArtistInfoText>{exploreFeaturedArtistName2}</ArtistInfoText>
                  <PriceTextContainer>
                    <img src={eth_icon} />
                    {exploreFeaturedSongPrice2}
                  </PriceTextContainer>
                </ArtistInfoRow>
              </SongInfo>
            </SwiperSlide>
            <SwiperSlide onClick={() => navigate(exploreFeaturedSongLink3)}>
              <SongCoverImg src={exploreFeaturedSongCover3} height={"200px"} />
              <SongInfo>
                <SongInfoName>{exploreFeaturedSongName3}</SongInfoName>
                <ArtistInfoRow>
                  <SongInfoProfilePic bg={exploreFeaturedArtistPic3} />
                  <ArtistInfoText>{exploreFeaturedArtistName3}</ArtistInfoText>
                  <PriceTextContainer>
                    <img src={eth_icon} />
                    {exploreFeaturedSongPrice3}
                  </PriceTextContainer>
                </ArtistInfoRow>
              </SongInfo>
            </SwiperSlide>
          </CustomSwiper>
        </>
      ) : (
        <></>
      )}
      <TopArtistsSection>
        <Column style={{ textAlign: "center" }}>
          <SectionTitle>TOP ARTISTS</SectionTitle>
          <SectionSubTitle>THE CREATIVE MINDS</SectionSubTitle>
        </Column>
        <TopArtistDesktop data-aos="fade-down">
          <Row align={"space-evenly"} style={{ marginTop: "5%" }}>
            {artistsTopRow.map((artist, index) => (
              <TopArtistProfile onClick={() => {onTopArtistClick(index)}}>
                <TopArtistProfilePic
                  bg={artistProfilePicsTopRow[index]}
                  outline={true}
                />
                <Text>{artist}</Text>
              </TopArtistProfile>
            ))}
          </Row>
          <Row
            align={"space-evenly"}
            style={{
              width: "80%",
              marginLeft: "auto",
              marginRight: "auto",
              marginTop: "-5%",
            }}
          >
            {artistsBottomRow.map((artist, index) => (
              <TopArtistProfile onClick={() => {onTopArtistBottomRowClick(index)}}>
                <TopArtistProfilePic
                  bg={artistProfilePicsBottomRow[index]}
                  outline={true}
                />
                <Text>{artist}</Text>
              </TopArtistProfile>
            ))}
          </Row>
        </TopArtistDesktop>
        <TopArtistMobile>
          <Row align={"space-evenly"} style={{ marginTop: "5%" }}>
            {artistsTopRow.map(
              (artist, index) =>
                index < 3 && (
                <TopArtistProfile onClick={() => {onTopArtistClick(index)}}>
                    <TopArtistProfilePic
                      bg={artistProfilePicsTopRow[index]}
                      outline={true}
                    />
                    <Text>{artist}</Text>
                  </TopArtistProfile>
                )
            )}
          </Row>
          <Row
            align={"space-evenly"}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {artistsBottomRow.map((artist, index) => (
              <TopArtistProfile onClick={() => {onTopArtistBottomRowClick(index)}}>
                <TopArtistProfilePic
                  bg={artistProfilePicsBottomRow[index]}
                  outline={true}
                />
                <Text>{artist}</Text>
              </TopArtistProfile>
            ))}
          </Row>
        </TopArtistMobile>
      </TopArtistsSection>

      <HowItWorksSection>
        <HowItWorksRow>
          <SectionTitle bold={true}>HOW IT WORKS</SectionTitle>
          <SectionSubTitle style={{ paddingBottom: "3%" }}>
            WHAT WE DO
          </SectionSubTitle>
          <div data-aos="fade-down">
            <HowItWorks />
          </div>
        </HowItWorksRow>
      </HowItWorksSection>

      <OurMissionSection>
        <Column style={{ justifyContent: "center", alignItems: "center" }}>
          <SectionTitle bold={true} size={"48px"}>
            OUR MISSION
          </SectionTitle>
          <SectionSubTitle>WHAT DRIVES US</SectionSubTitle>
        </Column>

        <OurMissionInfo data-aos="fade-down">
          <MissionItems>
            <MissionItem>
              <MissionItemText bold={true}>
                Introduce complete transparency and fairness in the music
                industry via the blockchain
              </MissionItemText>
            </MissionItem>

            <MissionItem>
              <MissionItemText bold={true}>
                Enable content creators to freely and fairly use the music of
                their choice in their work
              </MissionItemText>
            </MissionItem>

            <MissionItem>
              <MissionItemText bold={true}>
                Empower every musician to control the rights to their music.
              </MissionItemText>
            </MissionItem>

            <MissionItem>
              <MissionItemText bold={true}>
                Disrupt the music industries current revenue distribution model
                by allowing fans to invest in artists
              </MissionItemText>
            </MissionItem>
          </MissionItems>
        </OurMissionInfo>
      </OurMissionSection>

      <OurTeamSection>
        <Column style={{ justifyContent: "center", alignItems: "center" }}>
          <SectionTitle bold={true} size={"48px"}>
            OUR TEAM
          </SectionTitle>
          <SectionSubTitle>WHO WE ARE</SectionSubTitle>
        </Column>
        <OurTeamInfo data-aos="fade-down">
          <TeamRow>
            <Column style={{ textAlign: "center" }}>
              <NFTAvatars
                bg={stan}
                onClick={() => {
                  onAvatarClick("stan");
                }}
              />
              <Text bold={true} style={{ marginBottom: "0" }}>
                Stanton Thomas
              </Text>
              <br></br>
              Founder
            </Column>

            <Column style={{ textAlign: "center" }}>
              <NFTAvatars
                bg={vic}
                onClick={() => {
                  onAvatarClick("vic");
                }}
              />
              <Text bold={true} style={{ marginBottom: "0" }}>
                Victor Liang
              </Text>
              <br />
              Founder
            </Column>

            <Column style={{ textAlign: "center" }}>
              <NFTAvatars
                bg={eliska}
                onClick={() => {
                  onAvatarClick("eliska");
                }}
              />
              <Text bold={true} style={{ marginBottom: "0" }}>
                Eliska Patockova
              </Text>
              <br></br>
              Engineer
            </Column>
            <Column style={{ textAlign: "center" }}>
              <NFTAvatars
                bg={jazzy}
                onClick={() => {
                  onAvatarClick("jazzy");
                }}
              />
              <Text bold={true} style={{ marginBottom: "0" }}>
                Jazzy Liang
              </Text>
              <br></br>
              Product Designer
            </Column>
          </TeamRow>
        </OurTeamInfo>
      </OurTeamSection>

      <NewsletterSection>
        <NewsletterSectionColumn>
          <SectionTitle bold={true} size={"48px"}>
            NEWSLETTER
          </SectionTitle>
          <SectionSubTitle style={{ color: "rgba(255, 255, 255, 0.2)" }}>
            SIGN UP
          </SectionSubTitle>
          <NewsletterSearchContainer>
            <NewsLetterSearchBar
              type="email"
              placeholder="enter your email here"
              onChange={onEmailChange}
            />
            <NewsletterButton onClick={onNewsletterSignUpClick} type="submit">
              {signupText}
            </NewsletterButton>
          </NewsletterSearchContainer>

          <NewsletterButtonMobile
            onClick={onNewsletterSignUpClick}
            type="submit"
          >
            {signupText}
          </NewsletterButtonMobile>
        </NewsletterSectionColumn>
      </NewsletterSection>
      <Footer />
    </>
  );
};